module.exports = __webpack_public_path__ + "img/cca-html-level-1.b73837be.png";